import React from "react";
import { ShieldCheck, Clock, ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjBzbWlsZXxlbnwwfHx8fDE3ODE2NDMxNTl8MA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-36 md:pt-40 pb-20 md:pb-28 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(15,37,55,0.72)" }}
        aria-hidden="true"
      />

      <div className="container-x relative z-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8 text-white fade-in">
          <div
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm text-xs uppercase tracking-widest font-semibold mb-7"
          >
            <span className="inline-block w-2 h-2 rounded-full bg-[#7CC0B7]" />
            Trusted Local In-Home Care • 24/7 Availability
          </div>

          <h1
            data-testid="hero-heading"
            className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl"
          >
            Compassionate, Personalized Home Care
            <span className="block text-[#9BD3CB] mt-2">
              That Feels Like Family
            </span>
          </h1>

          <p
            data-testid="hero-subheading"
            className="mt-7 text-lg md:text-xl text-white/85 max-w-2xl leading-relaxed"
          >
            Providing trustworthy medical nursing, personal care assistance, and
            companionship in the comfort of your own home — across Edmonton,
            Calgary, and surrounding Alberta regions.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#booking"
              data-testid="hero-cta-primary"
              className="btn-primary"
            >
              Get Started
              <ArrowRight size={18} />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="btn-ghost-light"
            >
              Explore Services
            </a>
          </div>

          <div className="mt-12 flex flex-wrap gap-6 text-white/90">
            <div className="flex items-center gap-2 text-sm" data-testid="hero-trust-direct-billing">
              <ShieldCheck size={18} className="text-[#9BD3CB]" />
              <span>Direct Billing Available</span>
            </div>
            <div className="flex items-center gap-2 text-sm" data-testid="hero-trust-247">
              <Clock size={18} className="text-[#9BD3CB]" />
              <span>24/7 Caregiver Availability</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-4 hidden lg:block">
          <div
            data-testid="hero-stat-card"
            className="bg-white/95 backdrop-blur-md rounded-2xl p-8 shadow-2xl"
          >
            <div className="eyebrow">Why Families Choose Us</div>
            <div className="mt-4 space-y-5">
              <Stat number="4.9★" label="Average client rating" />
            </div>
            <a
              href="tel:+17809946439"
              data-testid="hero-call-card-cta"
              className="mt-6 block text-center btn-primary w-full"
            >
              Call 24/7: 780-994-6439
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ number, label }) => (
  <div className="flex items-baseline gap-3">
    <div className="font-display font-bold text-3xl aegis-navy-text">{number}</div>
    <div className="text-sm text-gray-600 leading-tight">{label}</div>
  </div>
);
